<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="w-full min-h-full pb-12 lg:py-0 bg-a-egg-f5ebdc text-a-brown-502314 lg:rounded-20 lg:px-14">
                    <div class="font-bold text-center py-4 lg:text-18">Details</div>
                    <div class="absolute top-4 lg:top-4 right-4 flex">
                        <img class="ml-auto mr-0" @click="clickCancel()" src="@/assets/icon/ic-close-brown.svg" />
                    </div>
                    <div class="bg-a-brown-e7d7c1 p-4 relative">
                        <div class="absolute top-0 left-3 h-full py-5 px-4 flex" >
                            <div class="my-auto h-4 border-l border-dashed border-a-brown-502314"></div>
                        </div>
                        <div class="flex pb-4">
                            <div class="w-6 flex">
                                <img class="mx-auto h-5 mb-0" src="@/assets/icon/ic-branch.svg" />
                            </div>
                            
                            <div class="pl-4">Burger King - {{getBranchName()}}</div>
                        </div>
                        <div class="flex">
                            <div class="w-6 flex">
                                <img class="mx-auto h-5 mt-0"  src="@/assets/icon/ic-destination.svg" />
                            </div>
                            
                            <div class="pl-4 h-5 address">{{orderItem.address ? orderItem.address : '-'}}</div>
                        </div>
                    </div>
                    <div class="p-4">
                        <div class="text-14 lg:text-16 text-a-brown-502314 border-b border-a-brown-d7c7b8 pb-2">
                            <div class="flex pb-2">
                                <div class="ml-0 mr-auto">{{ lbl.myOrder.orderNoLabel }}</div>
                                <div class="ml-auto mr-0">{{orderItem.tranId}}</div>
                            </div>
                            <div class="flex pb-2">
                                <div class="ml-0 mr-auto">{{ lbl.myOrder.orderType }}</div>
                                <div class="text-a-brown-502314">{{getOrderType()}}</div>
                            </div>
                            <div class="flex pb-2">
                                <div class="ml-0 mr-auto">{{ lbl.myOrder.estimateTime }}</div>
                                <div class="ml-auto mr-0" v-if="isSubscription">-</div>
                                <div class="ml-auto mr-0" v-else>{{getCompleteDate(orderItem.expectDelivery)}} - <span class="font-bold">{{getCompleteTime(orderItem.expectDelivery)}}</span></div>
                            </div>
                            <div class="flex pb-2">
                                <div class="ml-0 mr-auto">Status</div>
                                <div class="ml-auto mr-0" :class="[getStatusClass()]">{{getStatusText()}}</div>
                            </div>
                        </div>
                        <div class="text-14  lg:text-16 text-a-brown-502314">
                            <div class="pb-2">{{ lbl.myOrder.orderSummary }}</div>
                            <div class="py-2 border-b border-a-brown-d7c7b8" v-for="(detail,index) in orderDetail"
                                :key="index"
                                v-show="isMoreDetail || index ==0" >
                                <div class="flex">
                                    <div class="ml-0 mr-1 my-auto">
                                        <div class="py-0.5 px-1 border border-a-brown-502314 rounded-5 font-bold">{{detail.quantity}}x</div>
                                    </div>
                                    <div class="ml-0 mr-auto pr-1 campaign-name my-auto">{{detail.name}}</div>
                                    <div class="ml-auto mr-0">{{detail.pricePerUnit}} {{lbl.myOrder.bath}}</div>
                                </div>
                                <div class="pl-7">
                                    <p v-for="(other, otherIndex) in detail.others" :key="`other-item-${otherIndex}`">
                                        {{ other.Quantity }}x {{ localeCode == 1033 ? other.NameEN : other.Name }}
                                    </p>
                                    <!-- <div class="pt-3 text-12 lg:text-14" v-for="(chooses, choosesIndex) in detail.chooses"
                                        :key="`chooses-${choosesIndex}`">
                                        <p class="text-14 lg:text-16">{{ localeCode === 1033 ? chooses.headerEN : addon.header }}</p>
                                        <p v-for="(addonItem, addonItemIndex) in chooses.addonItems" :key="`addon-item-${addonItemIndex}`">
                                            {{ addonItem.Quantity }}x {{ localeCode == 1033 ? addonItem.NameEN : addonItem.Name }} (+{{ addonItem.TotalAmount }} {{lbl.myOrder.bath}})
                                        </p>
                                        <p v-for="(ingredientItems, ingredientItemIndex) in chooses.ingredientItems" :key="`ingredient-item-${ingredientItemIndex}`">
                                            {{ lbl.myOrder.except }} {{ localeCode == 1033 ? ingredientItems.NameEN : ingredientItems.Name }}
                                        </p>
                                    </div> -->
                                    <div class="pt-3 text-12 lg:text-14" v-for="(addons, addonsIndex) in detail.addons"
                                        :key="`addons-${addonsIndex}`">
                                        <p class="text-14 lg:text-16">{{ localeCode === 1033 ? addons.HeaderEN : addons.Header }}</p>
                                        <p v-for="(addonItem, addonItemIndex) in addons.Items" :key="`addon-item-${addonItemIndex}`">
                                            {{ addonItem.Quantity }}x {{ localeCode == 1033 ? addonItem.NameEN : addonItem.Name }} (+{{ addonItem.PricePerUnit }} {{lbl.myOrder.bath}})
                                        </p>
                                    </div>
                                    <div class="pt-3" v-for="(appetizers, appetizersIndex) in detail.appetizers"
                                        :key="`appetizers-${appetizersIndex}`">
                                        <p class="text-14">{{ localeCode === 1033 ? appetizers.HeaderEN : appetizers.Header }}</p>
                                        <p v-for="(appetizersItem, appetizersItemIndex) in appetizers.Items" :key="`appetizers-item-${appetizersItemIndex}`">
                                            {{ appetizersItem.Quantity }}x {{ localeCode == 1033 ? appetizersItem.NameEN : appetizersItem.Name }} (+{{ appetizersItem.PricePerUnit }} {{lbl.myOrder.bath}})
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="orderDetail.length > 1" @click="toggleDetail()" class="cursor-pointer text-14  lg:text-16 text-a-brown-502314 border-b border-a-brown-d7c7b8 py-2">
                            <div class="flex">
                                <div>{{ isMoreDetail ? lbl.myOrder.lessDetail : lbl.myOrder.moreDetail }}</div>
                                <img class="ml-auto mr-0 transform" 
                                    :class="[isMoreDetail ? 'rotate-180 duration-300' : 'rotate-0 duration-300']" 
                                    src="@/assets/icon/ic-arrow-down-brown.svg" />
                            </div>
                            <!-- <div class="flex" v-show="isMoreDetail">
                                <div>Less</div>
                                <img class="ml-auto mr-0" src="@/assets/icon/ic-arrow-down-brown.svg" />
                            </div> -->
                        </div>
                        <div class="text-14 lg:text-16 text-a-brown-502314 border-b border-a-brown-d7c7b8 py-2">
                            <div class="flex pb-2">
                                <div class="ml-0 mr-auto">{{ lbl.myOrder.subTotal }}</div>
                                <div class="ml-auto mr-0">{{FilterNumberFormat(orderItem.campaignAmount)}} {{lbl.myOrder.bath}}</div>
                            </div>
                            <div class="flex pb-2" v-if="orderItem.orderType != 'InStore'">
                                <div class="ml-0 mr-auto">{{ lbl.myOrder.deliveryFee }}</div>
                                <div class="ml-auto mr-0" v-if="orderItem.shippingAmount">{{ FilterNumberFormat(orderItem.shippingAmount) }} {{lbl.myOrder.bath}}</div>
                                <div class="ml-auto mr-0" v-else>-</div>
                            </div>
                            <div class="flex pb-2">
                                <div class="ml-0 mr-auto">{{ lbl.myOrder.discount }}</div>
                                <!-- <div class="ml-auto mr-0">{{orderItem.discount}}</div> -->
                                <div class="ml-auto mr-0" v-if="getDiscount() != 0">{{ FilterNumberFormat(getDiscount()) }} {{lbl.myOrder.bath}}</div>
                                <div class="ml-auto mr-0" v-else>-</div>
                            </div>
                            <div class="flex pb-2 text-16">
                                <div class="ml-0 mr-auto font-bold">{{ lbl.myOrder.total }}</div>
                                <div class="ml-auto mr-0 font-bold">{{orderItem.tranAmount}} {{lbl.myOrder.bath}}</div>
                            </div>
                        </div>
                        <div class="text-14 lg:text-16 text-a-brown-502314 py-2">
                            <div class="flex pb-2 ">
                                <div class="ml-0 mr-auto font-bold text-16">{{ lbl.myOrder.paymentDetails }}</div>
                                <div class="ml-auto mr-0" v-if="orderItem.channel == 'pod'">{{lbl.myOrder.cash}} </div>
                                <div class="ml-auto mr-0" v-if="orderItem.channel == 'omise'">{{lbl.myOrder.credit}} </div>
                                <div class="ml-auto mr-0 text-a-red-d62300" v-if="orderItem.channel == 'linepay'"><img class="inline-block mr-1" src="@/assets/shopping_cart/line-pay.png" />Rabbit LINE Pay</div>
                                <div class="ml-auto mr-0" v-if="orderItem.channel == 'omise_truewallet'">{{lbl.myOrder.truewallet}}</div>
                                <div class="ml-auto mr-0" v-if="orderItem.channel == 'omise_promptpay'">{{lbl.myOrder.promptpay}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="flex" v-if="!orderItem?.isSubscription">
                        <div class="w-52 m-auto pb-4" >
                            <WhiteButton  @click="clickOk()" customClass="font-bold p-2 w-full">
                                {{btnOk}}
                            </WhiteButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import WhiteButton from "@/components/Button/WhiteButton.vue";


export default {
    name: "OrderDetailModal",
    mixins: [LocaleMixin],
    components: {
        WhiteButton,
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            
            isMoreDetail: false,

            title: '',
            message: '',
            orderItem: null,
            orderDetail: [],
            total: 0,
            btnOk: '',
            btnCancel: '',
            busModal: null,
            isSubscription: false,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.orderItem = config.orderItem;
            this.orderDetail = config.orderDetail;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.isMoreDetail = false;

            if (this.orderItem.orderType == "Subscription") {
                this.isSubscription = true;
            } else {
                this.isSubscription = false;
            }
    
            

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk(this.campaignList);
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        getCompleteDate: function(completeDate) {
            return DatetimeHelper.timestampFullFormat(completeDate);
        },
        getCompleteTime: function(completeDate) {
            return DatetimeHelper.timeFormatShort2(completeDate);
        },
        getBranchName: function() {
            if (this.localeCode == 1033) {
                return this.orderItem.branchNameEN;
            } else {
                return this.orderItem.branchName;
            }
        },
        getStatusText: function () {
            if (this.isSubscription) {
                return this.lbl.myOrder.status_ordersubscription_complete;
            } else {
                if (this.orderItem.vendorStatus == 1) {
                    return this.lbl.myOrder.statusOrderPlaced;
                } else if (this.orderItem.vendorStatus == 2) {
                    return this.lbl.myOrder.statusOnRoute;
                } else if (this.orderItem.vendorStatus == 3) {
                    return this.lbl.myOrder.statusOrderComplete;
                } else if (this.orderItem.vendorStatus == 5) {
                    return this.lbl.myOrder.statusReadyToPick;
                } else if (this.orderItem.vendorStatus == 6) {
                    return this.lbl.myOrder.statusPickedUp;
                } else if (this.orderItem.vendorStatus == -1) {
                    return this.lbl.myOrder.statusCanceled;
                } else {
                    return this.myOrder.vendorStatusName;
                }
            }
            
        },
        getStatusClass: function () {
            if (this.isSubscription) {
                return "text-a-green-198737";
            } else { 
                if (this.orderItem.vendorStatus == 1) {
                    return "text-a-orange-ff8732";
                } else if (this.orderItem.vendorStatus == 2) {
                    return "text-a-orange-ff8732";
                } else if (this.orderItem.vendorStatus == 3) {
                    return "text-a-green-198737";
                } else if (this.orderItem.vendorStatus == 5) {
                    return "text-a-green-198737";
                } else if (this.orderItem.vendorStatus == 6) {
                    return "text-a-green-198737";
                } else if (this.orderItem.vendorStatus == -1) {
                    return "text-a-red-d62300";
                } else {
                    return "text-a-brown-502314";
                }
            }
            
        },
        toggleDetail: function() {
            this.isMoreDetail = !this.isMoreDetail;
        },
        getDiscount: function() {
            let sumDiscount = 0;
            if (this.orderItem.discount) {
                sumDiscount += this.orderItem.discount;
            }

            if (this.orderItem.deliveryDiscount) {
                sumDiscount += this.orderItem.deliveryDiscount;
            }
            return sumDiscount;
        },
        getPayment: function () {
            if (this.orderItem.channel == "omise") { 
                return this.lbl.myOrder.credit;
            } else {
                return this.lbl.myOrder.cash;
            }
        },
        getOrderType: function () {
            if (this.orderItem.orderType == "InStore") {
                if (this.orderItem.orderPlan == "TakeOut") {
                    return this.lbl.myOrder.orderTypeText.takeaway;
                } else {
                    return this.lbl.myOrder.orderTypeText.dinein;
                }
            } else if (this.orderItem.orderType == "Subscription") {
                return this.lbl.myOrder.orderTypeText.subscription;
            } else {
                return this.lbl.myOrder.orderTypeText.delivery;
            }
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/base/text.scss";
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        
        .modal-content {
            width: 100%;
            min-height: 100vh;
            @include min-desktop {
                width: 550px;
                min-height: 0;
            }
            
        }
        
        .campaign-name {
            @extend %ellipsis-2;
            max-width: 75%;
            max-height: 44px;
        }
        .address {
            @extend %ellipsis-1;
        }
    }
</style>
